const amIAdmin = (authorities: Array<string>) => (authorities || []).includes('sys_admin');
const amIAudit = (authorities: Array<string>) => (authorities || []).includes('sys_audit');

// アクセス制限リスト（ルール定義）
export const aclRules = acl => {
    // ナビバー管理メニュー
    acl.rule('show', 'AdminMenu', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));

    // ユーザー管理
    acl.rule('search', 'User', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(
        'show',
        'User',
        (user, dummy1, dummy2, pageUser) =>
            amIAdmin(user.authorities()) || amIAudit(user.authorities()) || user.id() === pageUser.id
    );
    acl.rule(['create', 'unlock', 'security', 'activate'], 'User', user => amIAdmin(user.authorities()));
    acl.rule(['updateName', 'updateMail', 'createAccessKey', 'updateAccessKey', 'deleteAccessKey'], 'User', user =>
        amIAdmin(user.authorities())
    );
    acl.rule(
        ['updatePassword', 'destroy'],
        'User',
        (user, dummy1, dummy2, pageUser) => amIAdmin(user.authorities()) || user.id() === pageUser.id
    );
    // 申請書の詳細のユーザーリンクを見れるのは管理者・監査者のみ
    acl.rule('edit', 'User', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));

    // ユーザーグループ管理
    acl.rule(['search', 'show'], 'UserGroup', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['create', 'update', 'destroy', 'addUsers', 'removeUsers'], 'UserGroup', user =>
        amIAdmin(user.authorities())
    );

    // ノードドメイン管理
    acl.rule(['search', 'show'], 'NodeDomain', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['create', 'update', 'destroy', 'connection'], 'NodeDomain', user => amIAdmin(user.authorities()));

    // ノードドメインアカウント管理
    acl.rule(['search', 'show'], 'DomainAccount', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(
        ['directSearch', 'create', 'update', 'destroy', 'connection', 'randomizableAccounts'],
        'DomainAccount',
        user => amIAdmin(user.authorities())
    );

    // ノードIdP管理
    acl.rule(['search', 'show'], 'NodeIdp', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['create', 'update', 'destroy', 'connection'], 'NodeIdp', user => amIAdmin(user.authorities()));

    // IdP種別管理
    acl.rule('index', 'IdpType', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));

    // ノードIdPアカウント管理
    acl.rule(['search', 'show'], 'IdpAccount', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['directSearch', 'create', 'destroy'], 'IdpAccount', user => amIAdmin(user.authorities()));

    // ノード管理
    acl.rule(['search', 'show'], 'Node', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(
        [
            'create',
            'update',
            'destroy',
            'osCreatedConnection',
            'domainConnection',
            'addApps',
            'removeApps',
            'addExcludes',
            'removeExcludes',
        ],
        'Node',
        user => amIAdmin(user.authorities())
    );

    // ノードタイプ管理
    acl.rule('index', 'NodeType', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));

    // ノードアカウント管理(パスワードランダム化対象のノード管理者アカウントと作業者アカウントの取得用)
    acl.rule(['randomizableAccounts'], 'NodeAccount', user => amIAdmin(user.authorities()));

    // ノード作業者アカウント(ドメイン)管理
    acl.rule(['index'], 'NodeDomainAccount', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['create', 'update', 'destroy'], 'NodeDomainAccount', user => amIAdmin(user.authorities()));

    // ノード作業者アカウント(OS)管理
    acl.rule(['search', 'show'], 'NodeOsAccount', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['directSearch', 'create', 'update', 'destroy', 'connection'], 'NodeOsAccount', user =>
        amIAdmin(user.authorities())
    );

    // ノード作業者アカウント(その他)管理
    acl.rule(
        ['search', 'show'],
        'NodeOtherAccount',
        user => amIAdmin(user.authorities()) || amIAudit(user.authorities())
    );
    acl.rule(['create', 'update', 'destroy', 'connection'], 'NodeOtherAccount', user => amIAdmin(user.authorities()));

    // ノード作業者アカウント(IdP)管理
    acl.rule(['index'], 'NodeIdpAccount', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['create', 'update', 'destroy'], 'NodeIdpAccount', user => amIAdmin(user.authorities()));

    // ノードグループ管理
    acl.rule(['search', 'show'], 'NodeGroup', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['create', 'update', 'destroy', 'addNodes', 'removeNodes'], 'NodeGroup', user =>
        amIAdmin(user.authorities())
    );

    // ユーザー設定
    acl.rule(['show', 'update', 'import', 'connection'], 'UserSetting', user => amIAdmin(user.authorities()));

    // メール設定
    acl.rule(['show', 'update', 'connection'], 'MailSetting', user => amIAdmin(user.authorities()));

    // 多要素認証デバイス管理
    acl.rule(
        ['search', 'show'],
        'MultifactorAuth',
        user => amIAdmin(user.authorities()) || amIAudit(user.authorities())
    );
    acl.rule(['create', 'update', 'destroy'], 'MultifactorAuth', user => amIAdmin(user.authorities()));

    // システム変更履歴
    acl.rule(['search'], 'SystemChangeHistory', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));

    // ジョブ実行履歴
    acl.rule(
        ['search', 'show'],
        'JobExecutionHistory',
        user => amIAdmin(user.authorities()) || amIAudit(user.authorities())
    );
    acl.rule(['retry'], 'JobExecutionHistory', user => amIAdmin(user.authorities()));

    // CSVファイル一覧画面
    acl.rule(['search', 'destroy'], 'Csv', user => amIAdmin(user.authorities()));

    // 検知ルール管理
    acl.rule(['search', 'show'], 'DetectionRule', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['create', 'update', 'destroy'], 'DetectionRule', user => amIAdmin(user.authorities()));

    // 検知ルールグループ管理
    acl.rule(
        ['search', 'show'],
        'DetectionRuleGroup',
        user => amIAdmin(user.authorities()) || amIAudit(user.authorities())
    );
    acl.rule(['create', 'update', 'destroy', 'addRules', 'removeRules'], 'DetectionRuleGroup', user =>
        amIAdmin(user.authorities())
    );

    // ワークフロー管理
    acl.rule(['search', 'show'], 'Workflow', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['create', 'update', 'destroy'], 'Workflow', user => amIAdmin(user.authorities(user.authorities())));

    // 業務システム管理
    acl.rule(
        ['search', 'show'],
        'BusinessSystem',
        user => amIAdmin(user.authorities()) || amIAudit(user.authorities())
    );
    acl.rule(['create', 'update', 'destroy'], 'BusinessSystem', user => amIAdmin(user.authorities(user.authorities())));

    // 申請書テンプレート
    acl.rule(['show'], 'ApplicationTemplate', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['directSearch', 'create', 'update', 'destroy'], 'ApplicationTemplate', user =>
        amIAdmin(user.authorities(user.authorities()))
    );

    // 業務
    acl.rule(['search', 'show'], 'AccountSet', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['directSearch', 'create', 'update', 'destroy'], 'AccountSet', user =>
        amIAdmin(user.authorities(user.authorities()))
    );

    // 定常作業テンプレート
    acl.rule(['show'], 'RoutineWorkTemplate', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['directSearch', 'create', 'update', 'destroy'], 'RoutineWorkTemplate', user =>
        amIAdmin(user.authorities(user.authorities()))
    );

    // 自動ログインアプリ管理
    acl.rule(['search', 'show'], 'AutoLoginApp', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['create', 'update', 'destroy'], 'AutoLoginApp', user => amIAdmin(user.authorities(user.authorities())));

    // 申請書管理番号
    acl.rule(['show', 'update'], 'AppManagementNumber', user => amIAdmin(user.authorities()));

    // 申請書
    acl.rule(['terminate'], 'ApplicationForm', user => amIAdmin(user.authorities()));
    acl.rule(
        ['workRecordsSummary'],
        'ApplicationForm',
        user => amIAdmin(user.authorities()) || amIAudit(user.authorities())
    );

    //特権ID貸出履歴詳細画面コメント欄
    acl.rule(['update'], 'PrivilegeIdLendingRecord', user => amIAdmin(user.authorities()));

    // 検知履歴
    acl.rule(
        ['search', 'show'],
        'DetectionRulesRecord',
        user => amIAdmin(user.authorities()) || amIAudit(user.authorities())
    );

    // ログイン履歴
    acl.rule(['search'], 'LoginRecord', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));

    // ダッシュボード
    acl.rule('index', 'AlertDashboard', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));

    // システム全体設定
    acl.rule(['show', 'update'], 'SystemSetting', user => amIAdmin(user.authorities()));

    // REC連携設定
    acl.rule(['show', 'update'], 'RecLinkageSetting', user => amIAdmin(user.authorities()));

    // ライセンス
    acl.rule(['index', 'create', 'show'], 'License', user => amIAdmin(user.authorities()));

    // 外部プログラム利用情報
    acl.rule(
        ['index', 'show'],
        'ExternalProgramUsage',
        user => amIAdmin(user.authorities()) || amIAudit(user.authorities())
    );
    acl.rule(['create', 'update', 'destroy'], 'ExternalProgramUsage', user => amIAdmin(user.authorities()));

    // ログイン失敗履歴
    acl.rule(['search'], 'LoginFailureRecord', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));

    // ログイン履歴収集除外条件
    acl.rule(
        ['index', 'search', 'show'],
        'NodeLoginHistoryExcludeCondition',
        user => amIAdmin(user.authorities()) || amIAudit(user.authorities())
    );
    acl.rule(['create', 'update', 'destroy'], 'NodeLoginHistoryExcludeCondition', user =>
        amIAdmin(user.authorities(user.authorities()))
    );

    // 定常作業テンプレート
    acl.rule(['show'], 'RoutineWorkTemplate', user => amIAdmin(user.authorities()) || amIAudit(user.authorities()));
    acl.rule(['create', 'update', 'destroy'], 'RoutineWorkTemplate', user =>
        amIAdmin(user.authorities(user.authorities()))
    );

    // アカウント棚卸結果差分
    acl.rule(
        ['search', 'show'],
        'AccountInventoryResultDiff',
        user => amIAdmin(user.authorities()) || amIAudit(user.authorities())
    );

    // アカウント棚卸設定
    acl.rule(
        ['search', 'show'],
        'AccountInventorySetting',
        user => amIAdmin(user.authorities()) || amIAudit(user.authorities())
    );
    acl.rule(
        [
            'create',
            'update',
            'destroy',
            'executeInventory',
            'addTargetNodeGroups',
            'removeTargetNodeGroups',
            'addTargetNodeDomains',
            'removeTargetNodeDomains',
            'updateSecurityGroups',
        ],
        'AccountInventorySetting',
        user => amIAdmin(user.authorities(user.authorities()))
    );

    // アカウント棚卸結果
    acl.rule(
        ['search', 'show'],
        'AccountInventoryResult',
        user => amIAdmin(user.authorities()) || amIAudit(user.authorities())
    );
    acl.rule(['retryInventory'], 'AccountInventoryResult', user => amIAdmin(user.authorities(user.authorities())));
    acl.rule(['diff'], 'AccountInventoryResult', user => amIAdmin(user.authorities(user.authorities())));
};
